import ConversionPanel, { Transformer } from "@components/ConversionPanel";
import React, { useCallback } from "react";

import { getWorker } from "@utils/workerWrapper";
import { useSettings } from "@hooks/useSettings";
import Form, { InputType } from "@/components/Form";
import { EditorPanelProps } from "@/components/EditorPanel";
import request from "@/utils/request";
import { Alert } from "evergreen-ui";

const formFields = [
  {
    type: InputType.SWITCH,
    key: "defaults",
    label: "defaults"
  },
  {
    type: InputType.SWITCH,
    key: "not_ie",
    label: "not ie < 11"
  },
  {
    type: InputType.SWITCH,
    key: "last2versions",
    label: "last 2 versions"
  },
  {
    type: InputType.SWITCH,
    key: "ios7",
    label: "iOS 7"
  },
  {
    type: InputType.SWITCH,
    key: "last3iosVersions",
    label: "last 3 iOS versions"
  }
];

interface Settings {
  autoprefixer: boolean;
  not_ie: boolean;
  last2versions: boolean;
  ios7: boolean;
  last3iosVersions: boolean;
}

let postCssWorker;
export default function ScssToCSS() {
  const name = "Scss to CSS";

  // TODO
  const [settings, setSettings] = useSettings(name, {
    defaults: true,
    not_ie: false,
    last2versions: false,
    ios7: false,
    last3iosVersions: false
  });

  const transformer = useCallback<Transformer>(
    async ({ value }) => {
      postCssWorker =
        postCssWorker ||
        getWorker(
          new Worker(new URL("@workers/postcss.worker", import.meta.url))
        );
      const css = await request("/api/sass-to-css", {
        value,
        syntax: "scss"
      });
      const _value = await postCssWorker.send({
        value: css,
        options: { syntax: "scss", ...settings }
      });
      return _value;
    },
    [settings]
  );

  const getSettingsElement = useCallback<EditorPanelProps["settingElement"]>(
    ({ open, toggle }) => {
      return (
        <Form<Settings>
          title="Scss to CSS"
          onSubmit={setSettings}
          open={open}
          toggle={toggle}
          formsFields={formFields}
          initialValues={settings}
        />
      );
    },
    []
  );

  return (
    <ConversionPanel
      transformer={transformer}
      resultTitle="CSS"
      editorTitle="Scss"
      editorLanguage="scss"
      resultLanguage="css"
      editorSettingsElement={getSettingsElement}
      settings={settings}
      resultEditorProps={{
        topNotifications: () => (
          <Alert
            backgroundColor="#e7f7ff"
            title="This scss to css code is converted on the server."
          />
        )
      }}
      editorProps={{
        acceptFiles: { "text/css": [".scss"] }
      }}
    />
  );
}
export { getStaticProps } from "@components/layouts/withI18n";
